import { render, staticRenderFns } from "./PassageRedirectNotice.vue?vue&type=template&id=42b819f0&"
import script from "./PassageRedirectNotice.vue?vue&type=script&lang=js&"
export * from "./PassageRedirectNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PassageRedirectNotice.vue"
export default component.exports